import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { TokenService } from '../auth/token.service';
import { StorageService } from '@app/servicios/storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardGuard implements CanActivate {
  realRol!: string;

  constructor(
    private tokenService: TokenService,
    private storageService: StorageService,
    private router: Router
  ) {}

  canActivate(): boolean {
    this.realRol = this.tokenService.isAdmin() ? 'mayorista' : 'publico';

    if (
      !this.tokenService.isLoggedIn() ||
      this.tokenService.notExpired() === false
    ) {
      this.storageService.removeItem('AuthTokenT');
      this.storageService.removeItem('userT');
      this.router.navigate(['/login']);
      return false;
    }

    if (!this.tokenService.isLoggedIn() || this.realRol == 'publico') {
      this.router.navigate(['/login']);
      return false;
    }

    return true;
  }
}
